module.exports = __webpack_public_path__ + "img/Analyze-amico.019870ef.svg";